import React, { lazy } from 'react';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ArrowRightIcon, MapPinIcon } from 'lucide-react';
export function KontaktPage() {
  return <div className="min-h-screen bg-white font-sans text-slate-900 selection:bg-[#59d0d4]/30 selection:text-[#3b7780] flex flex-col" data-id="element-570">
      <Navbar data-id="element-571" />
      <main className="flex-grow pt-32 pb-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto w-full" data-id="element-572">
        <div className="max-w-6xl mx-auto" data-id="element-573">
          <div className="text-center mb-16" data-id="element-574">
            <h1 className="text-3xl md:text-5xl font-extrabold text-slate-700 mb-6 tracking-tight" data-id="element-575">
              Kontakt & Anmeldung
            </h1>
            <p className="text-base sm:text-lg text-slate-500 max-w-2xl mx-auto font-medium" data-id="element-576">
              Haben Sie Fragen zu unseren Kursen oder möchten Sie sich anmelden?
              Wir freuen uns auf Ihre Nachricht.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start mb-20" data-id="element-577">
            {/* Image Side */}
            <div className="rounded-3xl overflow-hidden shadow-2xl aspect-[4/5] lg:aspect-auto lg:h-full sticky top-32" data-id="element-578">
              <img src="https://cdn.rawproductionsgmbh.de/2n/kontakt/kontakt.jpg" alt="Kontakt aufnehmen" className="w-full h-full object-cover" data-id="element-579" />
            </div>

            {/* Form Side */}
            <div className="bg-white border border-slate-200 shadow-xl rounded-3xl p-8 md:p-12" data-id="element-580">
              <form className="space-y-6" data-id="element-581">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-582">
                  <div data-id="element-583">
                    <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-584">
                      Vorname
                    </label>
                    <input type="text" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" data-id="element-585" />
                  </div>
                  <div data-id="element-586">
                    <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-587">
                      Nachname
                    </label>
                    <input type="text" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" data-id="element-588" />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-589">
                  <div data-id="element-590">
                    <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-591">
                      E-Mail
                    </label>
                    <input type="email" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" data-id="element-592" />
                  </div>
                  <div data-id="element-593">
                    <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-594">
                      Telefon
                    </label>
                    <input type="tel" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" data-id="element-595" />
                  </div>
                </div>

                <div data-id="element-596">
                  <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-597">
                    Betreff / Kursinteresse
                  </label>
                  <input type="text" className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700" placeholder="Wofür interessieren Sie sich?" data-id="element-598" />
                </div>

                <div data-id="element-599">
                  <label className="block text-sm font-bold text-slate-500 mb-2" data-id="element-600">
                    Nachricht
                  </label>
                  <textarea rows={6} className="w-full px-5 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-[#59d0d4] focus:border-[#59d0d4] outline-none transition-all font-medium text-slate-700 resize-none" placeholder="Ihre Nachricht an uns..." data-id="element-601"></textarea>
                </div>

                <button type="button" className="w-full bg-[#3b7780] hover:bg-[#2d5f66] text-white font-extrabold py-4 px-6 rounded-xl transition-all hover:scale-105 flex items-center justify-center gap-3 shadow-lg" data-id="element-602">
                  Jetzt Kursplan sichern <ArrowRightIcon className="w-5 h-5" data-id="element-603" />
                </button>
              </form>
            </div>
          </div>

          {/* Address & Map Section below form */}
          <div className="bg-slate-50 rounded-3xl p-8 md:p-12 border border-slate-100" data-id="element-604">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-605">
              <div data-id="element-606">
                <h3 className="text-2xl font-extrabold text-slate-700 mb-6 tracking-tight flex items-center gap-3" data-id="element-607">
                  <MapPinIcon className="w-6 h-6 text-[#59d0d4]" data-id="element-608" />
                  Unsere Adresse
                </h3>
                <p className="text-lg font-bold text-slate-700 mb-2" data-id="element-609">
                  2N Kurse GbR
                </p>
                <p className="text-slate-500 mb-1 font-medium" data-id="element-610">
                  Dres. Schwenk, Striegel, Herzog
                </p>
                <p className="text-slate-500 mb-1 font-medium" data-id="element-611">
                  Ludwigsplatz 1a
                </p>
                <p className="text-slate-500 mb-8 font-medium" data-id="element-612">
                  90403 Nürnberg
                </p>

                <a href="https://maps.app.goo.gl/dBPXpibLgyhH5JyE8" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 text-sm font-bold rounded-md text-white bg-[#3b7780] hover:bg-[#2d5f66] transition-all shadow-md" data-id="element-613">
                  Route auf Google Maps planen
                </a>
              </div>

              <div className="h-64 rounded-2xl overflow-hidden shadow-lg border border-slate-200" data-id="element-614">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2594.881452140409!2d11.07221877689121!3d49.45212507142273!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x479f57a6279930f7%3A0xcb1e220677a288c5!2sLudwigsplatz%201a%2C%2090403%20N%C3%BCrnberg!5e0!3m2!1sde!2sde!4v1709000000000!5m2!1sde!2sde" width="100%" height="100%" style={{
                border: 0
              }} allowFullScreen={false} loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Google Maps Standort" data-id="element-615"></iframe>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-616" />
    </div>;
}